export const BASEURL_API = process.env.REACT_APP_BASE_URL;
export const SUPER_ADMIN_COMPANYID = process.env.REACT_APP_SUPER_ADMIN_COMPANY_ID
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY
// export const GOOGLE_API_KEY = "AIzaSyB-yGpC4YxIsgGFtmWp19CAJkza_XVFpN4"

//for staging and production
export const MOVER_STORAGE_API_URL = process.env.REACT_APP_MOVER_STORAGE_API_URL
export const MOVEGISTICS_CMS_URL = process.env.REACT_APP_MOVEGISTICS_CMS_URL

// Staff roles that work shipment stages (app users, assignable as workers).
export const WORKER_ROLES = ["WORKER", "SUPERVISOR"]


//for local server
// const MOVER_STORAGE_API_URL = "https://storage-genie-api.apps.openxcell.dev/api/"

